export const VALUE_ANGLE_OFFSET = 5;

export function getColorByValue(value: number) {
  if (value >= 0 && value < 20) return "none";
  if (value >= 20 && value < 40) return "low";
  if (value >= 40 && value < 60) return "medium";
  if (value >= 60 && value < 80) return "high";
  if (value >= 80 && value <= 100) return "critical";
  return "none";
}
